import React from 'react';
import { Select } from 'antd';
import { taskTypes, statusTypes, urgencyTypes, advertiserTypes } from '../../configs/task.config';

const { Option } = Select;

const renderFilterSelect = ({ placeholder, value, onChange, options, mode = 'multiple' }) => (
  <Select
    className="task-filter-select"
    dropdownClassName="task-filter-dropdown"
    mode={mode}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    style={{ width: 140 }}
    maxTagCount={0}
    maxTagPlaceholder={(omittedValues) => `${omittedValues.length} selected`}
    allowClear
    filterOption={(input, option) =>
      option?.children?.toLowerCase?.()?.indexOf?.(input.toLowerCase()) >= 0
    }
    dropdownMatchSelectWidth={false}
    dropdownStyle={{ minWidth: 200 }}
  >
    {options}
  </Select>
);

const AnalyticsFilters = ({ filters, onFiltersChange, assigneeOptions = [], requestorOptions = [], channelPartnerOptions = [], advertiserOptions = [], teamOptions = [] }) => {
  const handleChange = (key, values) => {
    onFiltersChange({ ...filters, [key]: values });
  };

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
      {renderFilterSelect({
        placeholder: 'Assignee',
        value: filters.assignees || [],
        onChange: (v) => handleChange('assignees', v),
        options: assigneeOptions.map((opt) => (
          <Option key={opt.id} value={opt.id}>{opt.name}</Option>
        )),
      })}
      {renderFilterSelect({
        placeholder: 'Requestor',
        value: filters.requestors || [],
        onChange: (v) => handleChange('requestors', v),
        options: requestorOptions.map((opt) => (
          <Option key={opt.id} value={opt.id}>{opt.name}</Option>
        )),
      })}
      {renderFilterSelect({
        placeholder: 'Request Type',
        value: filters.requestTypes || [],
        onChange: (v) => handleChange('requestTypes', v),
        options: taskTypes.map((type) => (
          <Option key={type} value={type}>{type}</Option>
        )),
      })}
      {renderFilterSelect({
        placeholder: 'Status',
        value: filters.statuses || [],
        onChange: (v) => handleChange('statuses', v),
        options: Object.entries(statusTypes).map(([label, value]) => (
          <Option key={value} value={value}>{label}</Option>
        )),
      })}
      {renderFilterSelect({
        placeholder: 'Urgency',
        value: filters.urgencies || [],
        onChange: (v) => handleChange('urgencies', v),
        options: Object.entries(urgencyTypes).map(([label, value]) => (
          <Option key={value} value={value}>{label}</Option>
        )),
      })}
      {renderFilterSelect({
        placeholder: 'Adv. Type',
        value: filters.advertiserTypes || [],
        onChange: (v) => handleChange('advertiserTypes', v),
        options: Object.entries(advertiserTypes).map(([label, value]) => (
          <Option key={value} value={value}>{label}</Option>
        )),
      })}
      {renderFilterSelect({
        placeholder: 'Channel Partner',
        value: filters.channelPartners || [],
        onChange: (v) => handleChange('channelPartners', v),
        options: channelPartnerOptions.map((opt) => (
          <Option key={opt.name} value={opt.name}>{opt.name}</Option>
        )),
      })}
      {renderFilterSelect({
        placeholder: 'Advertiser',
        value: filters.advertisers || [],
        onChange: (v) => handleChange('advertisers', v),
        options: advertiserOptions.map((opt) => (
          <Option key={opt.name} value={opt.name}>{opt.name}</Option>
        )),
      })}
      {renderFilterSelect({
        placeholder: 'Team',
        value: filters.teams || [],
        onChange: (v) => handleChange('teams', v),
        options: teamOptions.map((opt) => (
          <Option key={opt.id} value={opt.id}>{opt.name}</Option>
        )),
      })}
    </div>
  );
};

export default AnalyticsFilters;
